import useDeckActions from 'components/deckPage/actions/menuActions'
import { useMobileControlToggles } from 'hooks/useMobileControlToggles.module'
import { useHideFloatingToolbar } from 'hooks/useBrowserSettings'
import { useCanEditDeck } from 'app-redux/deck/selectors'

import { SubComponentProps } from 'components/elements/FloatingToolbar/types'

import FloatingToolbarListOption from 'components/elements/FloatingToolbar/ListItem'
import PhatButton from 'components/formElements/PhatButton'
import Link from 'components/elements/Link'
import ToggleSwitch from 'components/formElements/ToggleSwitch'

import styles from './mobileDeckMoreMenu.module.scss'

const MobileDeckMoreMenu = ({ onClose }: SubComponentProps) => {
  const actions = useDeckActions(onClose)

  const canEditDeck = useCanEditDeck()

  const [mobileControls, setMobileControls] = useMobileControlToggles()
  const [staticFloatingToolbar, setStaticFloatingToolbar] = useHideFloatingToolbar()

  const playtesterButton = actions.playtester.to ? (
    <Link href={actions.playtester.to}>
      <PhatButton onClick={actions.playtester.onClick} icon={actions.playtester.icon}>
        {actions.playtester.label}
      </PhatButton>
    </Link>
  ) : (
    <PhatButton onClick={actions.playtester.onClick} icon={actions.playtester.icon}>
      {actions.playtester.label}
    </PhatButton>
  )

  return (
    <div className={styles.options}>
      <div className={styles.prominent}>
        {playtesterButton}

        <PhatButton onClick={actions.settings.onClick} icon={actions.settings.icon} disabled={actions.settings.hidden}>
          {actions.settings.label}
        </PhatButton>
      </div>

      {canEditDeck && (
        <>
          <h5>Add / remove cards</h5>
          <FloatingToolbarListOption {...actions.import} className={styles.newDeckIndicator} />
          <FloatingToolbarListOption {...actions.recs} />
          <FloatingToolbarListOption {...actions.precons} className={styles.newDeckIndicator} />
          <FloatingToolbarListOption {...actions.packages} className={styles.newDeckIndicator} />
        </>
      )}

      <h5>Deck info</h5>
      <FloatingToolbarListOption {...actions.history} />
      <FloatingToolbarListOption {...actions.export} />
      <FloatingToolbarListOption {...actions.clone} />
      <FloatingToolbarListOption {...actions.stats} />

      <h5>Misc</h5>

      <FloatingToolbarListOption {...actions.buySell} />

      <FloatingToolbarListOption {...actions.share} />
      <FloatingToolbarListOption {...actions.deckHelp} />
      <FloatingToolbarListOption {...actions.addToCollection} />

      <FloatingToolbarListOption {...actions.selectAll} />

      <FloatingToolbarListOption {...actions.compare} />

      <FloatingToolbarListOption {...actions.optimizePrintings} />

      <FloatingToolbarListOption {...actions.optimizeBasics} />
      <FloatingToolbarListOption {...actions.customCards} />

      <FloatingToolbarListOption {...actions.description} />

      <FloatingToolbarListOption {...actions.containingFolder} />
      <FloatingToolbarListOption {...actions.sandbox} />

      <FloatingToolbarListOption {...actions.bookmark} />

      <FloatingToolbarListOption {...actions.report} />

      <h5>Options</h5>
      <ToggleSwitch
        label="Hide toolbar on scroll"
        onChange={() => setStaticFloatingToolbar(!staticFloatingToolbar)}
        checked={!staticFloatingToolbar}
        className={styles.toggle}
      />

      <ToggleSwitch
        label="Pin vertical toolbar adjacent to deck"
        onChange={() => setMobileControls({ stickyBar: !mobileControls.stickyBar })}
        checked={mobileControls.stickyBar}
        className={styles.toggle}
      />
    </div>
  )
}

export default MobileDeckMoreMenu
